import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_VDOLIVESETTOPIC,
  GET_VDOLIVESETTOPICS,
  GET_VDOLIVESETTOPICS_BY_FILTER,
  ADD_VDOLIVESETTOPIC,
  UPDATE_VDOLIVESETTOPIC,
  DELETE_VDOLIVESETTOPIC
} from '@/queries/modules/live-class/vdo-live-set-topic.js';

export async function getVdoLiveSetTopics(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOLIVESETTOPICS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoLiveSetTopics', data.getVdoLiveSetTopics);
      context.commit('setSuccess', null);
      return data.getVdoLiveSetTopics
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoLiveSetTopicsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOLIVESETTOPICS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoLiveSetTopics', data.getVdoLiveSetTopicsByFilter);
      context.commit('setSuccess', null);

      return data.getVdoLiveSetTopicsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoLiveSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOLIVESETTOPIC,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setVdoLiveSetTopic', data.getVdoLiveSetTopic);
      context.commit('setSuccess', null);
      return data.getVdoLiveSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addVdoLiveSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_VDOLIVESETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const vdoLiveSetTopics = [...context.state.vdoLiveSetTopics];
      vdoLiveSetTopics.push(data.addVdoLiveSetTopic);
      context.commit('setVdoLiveSetTopics', vdoLiveSetTopics);
      context.commit('setSuccess', newItemSuccess(data.addVdoLiveSetTopic.nameLocal));

      return data.addVdoLiveSetTopic;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateVdoLiveSetTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_VDOLIVESETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.vdoLiveSetTopics.findIndex(item => item.id === data.updateVdoLiveSetTopic.id);
      const vdoLiveSetTopics = [
        ...context.state.vdoLiveSetTopics.slice(0, index),
        data.updateVdoLiveSetTopic,
        ...context.state.vdoLiveSetTopics.slice(index + 1)
      ];
      context.commit('setVdoLiveSetTopics', vdoLiveSetTopics);
      context.commit('setSuccess', updateItemSuccess(data.updateVdoLiveSetTopic.nameLocal));

      return data.updateVdoLiveSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteVdoLiveSetTopic(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_VDOLIVESETTOPIC,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.vdoLiveSetTopics.findIndex(item => item.id === data.deleteVdoLiveSetTopic.id);
      const vdoLiveSetTopics = [
        ...context.state.vdoLiveSetTopics.slice(0, index),
        ...context.state.vdoLiveSetTopics.slice(index + 1)
      ];
      context.commit('setVdoLiveSetTopics', vdoLiveSetTopics);
      context.commit('setSuccess', deleteItemSuccess(data.deleteVdoLiveSetTopic.nameLocal));

      return data.deleteVdoLiveSetTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

